import { render, staticRenderFns } from "./tzfgSet.vue?vue&type=template&id=49c425f8&scoped=true&"
import script from "./tzfgSet.vue?vue&type=script&lang=js&"
export * from "./tzfgSet.vue?vue&type=script&lang=js&"
import style0 from "./tzfgSet.vue?vue&type=style&index=0&id=49c425f8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c425f8",
  null
  
)

export default component.exports